<template>
  <v-container fluid id="services" class="section-height pa-0 ma-0">
    <v-row no-gutters class="section-height">
      <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp" class="d-flex justify-center">
        <v-img
          max-height="100vh"
          src="../../../public/pictures/21.jpg"
        />
      </v-col>
      <v-col class="d-flex flex-column justify-center title text-center font-weight-light px-5">
        <div>
          <v-col>
            Для меня психотерапия – это процесс совместного исследования, поиска смыслов, ресурсов, внутренних опор,
            ценностей, путей для изменений. Это создание безопасного пространства доверительных отношений, которое
            дает возможность получить новый опыт. Это движение к целостности и осознанию себя.
          </v-col>
          <v-col>
            Подробнее о том, что для меня значит психотерапия, можно почитать
            <router-link to="/about" class="align-center">здесь</router-link>
            .
          </v-col>
        </div>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
name: "Therapy"
}
</script>

<style scoped>

</style>